import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  description?: string | React.ReactNode;
  date?: string;
  children?: React.ReactNode;
}

/**
 * A reusable page header component that provides a consistent styling across the site.
 * It creates a full-width header with a title, optional description, date, and children.
 * 
 * @param {string} title - The main title to display
 * @param {string|React.ReactNode} description - Optional description text
 * @param {string} date - Optional date to display (e.g. "Last updated: May 29, 2025")
 * @param {React.ReactNode} children - Optional additional content to render inside the header
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, description, date, children }) => {
  return (
    <div className="page-header">
      <div className="container">
        <h1>{title}</h1>
        {date && <p className="page-date">{date}</p>}
        {description && <p className="page-description">{description}</p>}
        {children}
      </div>
    </div>
  );
};

export default PageHeader;
